import React from "react";
import { RCCGrid, RCCHidden } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { ISwotItem } from "src/pages/Analysis/SWOT/interface";
import swotLabels from "src/pages/Analysis/SWOT/SwotLabels";
import { v4 } from "uuid";
import { UlTable } from "../../styles";

export interface ISwotItemBonds{
    swotItens: ISwotItem[];
}

const SwotItemBonds: React.FC<ISwotItemBonds> = ({
	swotItens
}) => {
	const { translate } = useTranslation();
	const {swotSections} = swotLabels(translate);	

	return(
		<>
			{swotSections.map((swot) =>
				swotItens?.some((x) => x.mes002Secao === swot.type) &&
                <UlTable key={v4() }>
                	<li className="list-component-child"
                		style={{backgroundColor:swot.color, color:"white", fontWeight:"bold"}}>
                		<RCCGrid item container sm={10}>
                			<span>
                				{swot.title}
                			</span>
                		</RCCGrid>
                	</li>
                	<li className="list-component-header">
                		<RCCGrid item container
                			sm={10}
                		>
                			<span>
                				{translate("Item")}
                			</span>
                		</RCCGrid>
                		<RCCGrid item container
                			sm={2}
                		>
                			<span>
                				{translate("Pontuação")}
                			</span>
                		</RCCGrid>
                	</li>
                	{swotItens?.filter((x) => x.mes002Secao === swot.type)?.map((item) => 
                		<li className="list-component-child" key={v4() }>
                			<RCCGrid item container
                				xs={12}
                				sm={10}
                			>
                				<span>
                					<RCCHidden smUp><b>{translate("Item")}:</b> </RCCHidden>
                					{item.dimensionText && 
                                        <span style={{color:"var(--grey)"}}>[{item.dimensionText}] </span>
                					}
                					{item.mes002Titulo}
                				</span>
                			</RCCGrid>
                			<RCCGrid item container
                				xs={12}
                				sm={2}
                			>
                				<span>
                					<RCCHidden smUp><b>{translate("Pontuação")}:</b></RCCHidden>{item.mes002Pontuacao}
                				</span>
                			</RCCGrid>
                		</li>
                	)}
                </UlTable>
			)}
		</>
	);
};

export default SwotItemBonds;
